// Validação de CPF e CNPJ pelos dígitos verificadores (regras da Receita Federal).
// Espelha o backend (sindicoapp/core/documento_br.py) para dar feedback na hora.
// CNPJ suporta o novo formato alfanumérico (12 posições 0-9/A-Z + 2 DV numéricos).

function soDigitos(s: string): string {
  return (s || "").replace(/\D/g, "");
}

export function cpfValido(valor: string): boolean {
  const cpf = soDigitos(valor);
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;
  for (const [pos, pesoIni] of [[9, 10], [10, 11]] as const) {
    let soma = 0;
    for (let i = 0; i < pos; i++) soma += parseInt(cpf[i], 10) * (pesoIni - i);
    const resto = (soma * 10) % 11;
    const dv = resto === 10 || resto === 11 ? 0 : resto;
    if (dv !== parseInt(cpf[pos], 10)) return false;
  }
  return true;
}

const PESOS1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function dvCnpj(base: string, pesos: number[]): number {
  let soma = 0;
  for (let i = 0; i < base.length; i++) soma += (base.charCodeAt(i) - 48) * pesos[i];
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function cnpjValido(valor: string): boolean {
  const cnpj = (valor || "").replace(/[^0-9A-Za-z]/g, "").toUpperCase();
  if (cnpj.length !== 14 || new RegExp(`^(.)\\1{13}$`).test(cnpj)) return false;
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false;
  if (dvCnpj(cnpj.slice(0, 12), PESOS1) !== parseInt(cnpj[12], 10)) return false;
  return dvCnpj(cnpj.slice(0, 13), PESOS2) === parseInt(cnpj[13], 10);
}

/** Devolve 'cpf' | 'cnpj' | null pelo tamanho (após limpar). */
export function tipoDocumento(valor: string): "cpf" | "cnpj" | null {
  const nCpf = soDigitos(valor).length;
  const nCnpj = (valor || "").replace(/[^0-9A-Za-z]/g, "").length;
  if (nCnpj === 14) return "cnpj";
  if (nCpf === 11) return "cpf";
  return null;
}

/** Valida CPF (11) ou CNPJ (14) automaticamente. Vazio conta como válido (opcional). */
export function documentoValido(valor: string): boolean {
  if (!(valor || "").trim()) return true;
  const t = tipoDocumento(valor);
  if (t === "cpf") return cpfValido(valor);
  if (t === "cnpj") return cnpjValido(valor);
  return false;
}
